import styles from './FeedbackForm.css'
import CustomerFeedbackForm from './CustomerFeedbackForm'
import {feedbackFormPageRequest, submitFeedback} from 'actions/feedbackForm'
import {connect} from 'react-redux'

class FeedbackForm extends React.Component {
  componentDidMount () {
    let {token, quality} = this.props.params
    this.props.dispatch(feedbackFormPageRequest({feedback_token: token, quality: quality}))
  }

  render () {
    let {invalidFeedback, submitSuccess, dataFeedbackToken, showFeedbackForm} = this.props
    let {quality} = this.props.params
    return (dataFeedbackToken &&
      <div className={styles['feedback-wrapper']}>
        {invalidFeedback && <div className={styles.title}>
          {dataFeedbackToken.business_and_outlet_info}
        </div>}

        {invalidFeedback
          ? dataFeedbackToken.feedback_mode === 'sad'
            ? <div className={styles['image-mode']}>
              <img src='https://dev.mokapos.com/assets/sad-icon.png' className={styles.emoji} />
            </div>
            : <div className={styles['image-mode']}>
              <img src='https://dev.mokapos.com/assets/smile-icon.png' className={styles.emoji} />
            </div>
          : quality === 'sad'
            ? <div className={styles['image-mode']}>
              <img src='https://dev.mokapos.com/assets/sad-icon.png' className={styles.emoji} />
            </div>
            : <div className={styles['image-mode']}>
              <img src='https://dev.mokapos.com/assets/smile-icon.png' className={styles.emoji} />
            </div>
        }

        {invalidFeedback &&
          <div>
            <p className={styles['invalid-message']}>
              You&#39;ve already left feedback for this transaction.
            </p>
          </div>}

        {showFeedbackForm && <div className={styles['wrapper-form']}>
          {quality === 'happy'
            ? <div className={styles.subtitle}>
              <h2>That&#39;s Great</h2>
              <p>Tell us what we got right</p>
            </div>
            : <div className={styles.subtitle}>
              <h2>We&#39;re really sorry</h2>
              <p>Tell us what&#39;s wrong</p>
            </div>}
          <div className={styles['feed-form']}>
            <CustomerFeedbackForm onSubmit={this.handleSubmit} />
          </div>
        </div>}

        {submitSuccess &&
          <div className={styles['success-message']}>
            <h2>Thank you!</h2>
          </div>}
      </div>
    )
  }

  handleSubmit = (values) => {
    let {feedbackType, comment} = values
    let {token, quality} = this.props.params
    let {query} = this.props.location
    this.props.dispatch(submitFeedback({
      feedback_type: feedbackType,
      comment: comment,
      feedback_token: token,
      mode: quality,
      customer_id: query.cid ? query.cid : '',
      feedback_from: query.feedback_form ? query.feedback_form : null
    }))
  }
}

function mapStateToProps (state) {
  const {
    invalidFeedback,
    submitSuccess,
    dataFeedbackToken,
    showFeedbackForm} = state.feedbackForm
  return {
    invalidFeedback,
    submitSuccess,
    dataFeedbackToken,
    showFeedbackForm
  }
}

export default connect(mapStateToProps)(FeedbackForm)



// WEBPACK FOOTER //
// ./app/pages/FeedbackForm/FeedbackForm.js